// CommonModal.tsx
import React from "react";
import styled from "styled-components";

const ModalOverlay = styled.div`
  position: fixed;
  z-index: 1000;
  left: 0; top: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalBox = styled.div`
  background: #fff;
  border-radius: 6px;
  padding: 36px 28px 28px 28px;
  min-width: 320px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.10);
  text-align: center;
`;

const Message = styled.div`
  font-size: 1rem;
  color: #222;
  margin-bottom: 32px;
  line-height: 1.6;
  word-break: keep-all;
`;

const ConfirmButton = styled.button`
  width: 100%;
  padding: 10px 0;
  background: #ff6900;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s;
  &:hover {
    background: #ff9a3c;
  }
`;

interface EvModalProps {
  open: boolean;
  message?: string;
  buttonText?: string;
  onClose: () => void;
  children?: React.ReactNode;
}

export default function EvModal({
  open,
  message,
  buttonText = "확인",
  onClose,
  children,
}: EvModalProps) {
  if (!open) return null;
  return (
    <ModalOverlay>
      <ModalBox>
        {message && <Message>{message}</Message>}
        {children}
        <ConfirmButton onClick={onClose}>{buttonText}</ConfirmButton>
      </ModalBox>
    </ModalOverlay>
  );
}